var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticClass:"el-headers"},[_c('Header')],1),_c('el-container',[_c('el-aside',{attrs:{"width":"10%"}},[_c('Menus')],1),_c('el-main',{staticClass:"mainBg"},[_c('div',{staticClass:"infinite-list-wrapper",staticStyle:{"overflow":"auto"}},[_c('router-view')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }